import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  FaUserShield,
  FaCreditCard,
  FaTruck,
  FaDollarSign,
} from "react-icons/fa";

const features = [
  {
    icon: <FaUserShield className="text-white text-2xl" />,
    title: "Kalıcı Veri Temizliği",
    description:
      "Delta Servis, Kalıcı Veri Temizliği hizmetiyle cihazındaki tüm hassas bilgileri geri döndürülemez biçimde siler. Böylece kimlik, fotoğraf veya mesaj gibi kişisel verilerin hiçbir üçüncü tarafça ele geçirilemez. Güvenlik, Delta Servis’in öncelikli değerlerinden olup, özel yazılımlarımız sayesinde veri kurtarma girişimleri sonuçsuz kalır. Satış ya da devir işlemlerini endişe duymadan gerçekleştirebilmen için kapsamlı bir silme protokolü uygulanır. Böylece veri gizliliğin daimî korunması sağlanır. Delta Servis, teknik uzmanlığıyla her aşamada yanındadır.",
  },
  {
    icon: <FaCreditCard className="text-white text-2xl" />,
    title: "Hızlı Ödeme",
    description:
      "Delta Servis, Hızlı Ödeme yaklaşımıyla cihaz satışında gereksiz beklemeleri ortadan kaldırır. Onay süreci biter bitmez hak ettiğin tutar anında hesabına aktarılır. Güvenilir finansal altyapı ve korunaklı işlem adımları sayesinde verimlilik artar, süpriz kesintiler görülmez. Zamanı değerli olanlar için Delta Servis’in hızlı ödeme politikası ideal bir çözümdür. Böylece satıştan sonra hemen yeni yatırımlarına odaklanabilirsin. Kullanıcı memnuniyetini her zaman ön planda tutar.",
  },
  {
    icon: <FaTruck className="text-white text-2xl" />,
    title: "Ücretsiz Kargo",
    description:
      "Delta Servis, Ücretsiz Kargo seçeneğiyle cihazını bize ek masraf olmadan ulaştırmanı sağlar. Anlaşmalı kargo firmalarıyla çalışarak süreci güvence altına alır ve kesintisiz takip hizmeti sunar. Paketleme ve gönderim aşamalarında oluşabilecek riskleri asgari düzeye indirir, böylece cihazını rahatlıkla yola çıkarabilirsin. Kargo süreçlerinde sürpriz maliyetlerle karşılaşmaz, her aşamada detaylı bilgilendirme alırsın. Kolay, güvenli ve masrafsız gönderim Delta Servis’in önceliklerindendir.",
  },
  {
    icon: <FaDollarSign className="text-white text-2xl" />,
    title: "En İyi Fiyat",
    description:
      "Delta Servis, En İyi Fiyat teklifiyle cihazından maksimum kazanç elde etmeni sağlar. Piyasa koşullarını sürekli takip eden uzman ekibimiz, her zaman rekabetçi ve adil teklifler sunar. Böylece kullanmadığın ya da yenilemek istediğin cihazı gerçek değerinde satabilirsin. Şeffaf değerlendirme süreçleri, güvenilir ödeme altyapısıyla bir araya gelerek memnuniyetini ön planda tutar. Yüksek kazançlı ve zahmetsiz bir satış deneyimi için Delta Servis her zaman en avantajlı rakamları sağlamayı hedefler.",
  },
];


const PromoSection = () => {
  const [selectedFeature, setSelectedFeature] = useState(features[1]);

  return (
    <div className="w-full flex justify-center py-16 px-4 bg-gray-50">
      <div className="bg-black text-white rounded-2xl p-10 max-w-6xl w-full flex flex-col md:flex-row items-center gap-10 shadow-lg">
        <div className="flex-1 flex flex-col justify-between h-[70%]">
          <h2 className="text-4xl md:text-5xl font-bold leading-tight">
            Delta Buyback ile
            <br /> Cihazını Değerinde Sat
          </h2>

          {/* ANİMASYONLU YAZI */}
          <motion.p
            key={selectedFeature.title} // değişiklikleri takip etmesi için key verdik
            className="text-gray-400 text-md leading-relaxed"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            {selectedFeature.description}
          </motion.p>
        </div>

        <div className="bg-[#121212] rounded-2xl p-6 w-full md:w-[400px] shadow-lg">
          <div className="space-y-4">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`flex items-center gap-4 p-4 rounded-lg transition cursor-pointer ${
                  selectedFeature.title === feature.title
                    ? "bg-[#1E1E1E] border border-gray-600"
                    : "bg-[#1E1E1E]"
                }`}
                onClick={() => setSelectedFeature(feature)} // TIKLANINCA METİN DEĞİŞECEK
              >
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-lg border-[3px] border-transparent"
                  style={{
                    background:
                      "linear-gradient(black, black) padding-box, linear-gradient(to right, #FF6A3D, #735DFF) border-box",
                  }}
                >
                  <div className="text-white text-2xl">{feature.icon}</div>
                </div>

                <div className="flex-1">
                  <h3 className="text-white font-medium flex items-center gap-2">
                    {feature.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>

          <button className="w-full mt-6 bg-white text-black font-semibold py-3 rounded-md shadow-md hover:bg-gray-200 transition">
            Cihazını Hemen Sat
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoSection;
